exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pay-in__col-method .vs__dropdown-toggle {\n  padding: 4px 0;\n  cursor: pointer;\n}\n.pay-in__col-method .vs__selected-options {\n  min-height: 2rem;\n  padding-left: 8px;\n}\n.pay-in__col-method .vs__selected {\n  padding-left: 0;\n}\n.pay-in__col-method .vs__dropdown-option {\n  padding: 3px 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-66a6ff06","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationPayIn/PaymentMethodForm.vue
// module id = 1999
// module chunks = 0